import React from 'react';
import { BellOutlined } from '@ant-design/icons';
import RadioCardGroup from '../settings/RadioCardGroup';
import { ForwardingNotifyMode } from '../../types';
import css from './ForwardingNotifyModeSelector.module.scss';

interface ForwardingNotifyModeSelectorProps {
  value: ForwardingNotifyMode;
  disabled?: boolean;
  onChange: (mode: ForwardingNotifyMode) => void;
}

const options = [
  {
    value: 'auto' as ForwardingNotifyMode,
    label: 'Manual forwards only',
    description: 'Default — confirmation when you forward an email yourself.',
  },
  {
    value: 'always' as ForwardingNotifyMode,
    label: 'Always',
    description: 'Email me whenever a forwarded reply is attached.',
  },
  {
    value: 'never' as ForwardingNotifyMode,
    label: 'Never',
    description: "Don't email me — I'll see updates in the app.",
  },
];

const ForwardingNotifyModeSelector: React.FC<ForwardingNotifyModeSelectorProps> = ({
  value,
  disabled,
  onChange,
}) => (
  <RadioCardGroup
    legend="Confirmation emails"
    icon={<BellOutlined />}
    name="forwarding-notify-mode"
    ariaLabel="Confirmation email frequency"
    options={options}
    value={value}
    onChange={onChange}
    disabled={disabled}
    className={css.fieldset}
  >
    <p className={css.lead}>
      When should Job Beast email you to confirm a forwarded reply was attached?
    </p>
  </RadioCardGroup>
);

export default ForwardingNotifyModeSelector;
